import React, { useEffect } from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import TabPageContainer from '~components/atoms/TabPageContainer';
import GoldInventoryApprovalSearchAndFilterBar from './GoldInventoryApprovalSearchAndFilterBar';
import GoldInventoryApprovalTable from './GoldInventoryApprovalTable';
import GoldInventoryApprovalPaginator from './GoldInventoryApprovalPaginator';
import ConfirmUpdateInventoryTransactionStatusModal from './ConfirmUpdateInventoryTransactionStatusModal';

const GoldSilverInventoryApproval = () => {
    const dispatch = useAppDispatch();

    const transactionListingIndex = useAppSelector(state => state.approval.pendingInventoryTransactionListing.index);

    useEffect(() => {
        dispatch(combinedActions.approvalGetPendingInventoryTransactionListingAttempt());
    }, [transactionListingIndex]);

    return (
        <TabPageContainer>
            <GoldInventoryApprovalSearchAndFilterBar />

            <GoldInventoryApprovalTable />

            <GoldInventoryApprovalPaginator />

            <ConfirmUpdateInventoryTransactionStatusModal />
        </TabPageContainer>
    );
};

export default GoldSilverInventoryApproval;
